"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var VistaprintAuth = require('@vp/auth');

var ctcReader = require('@vp/ctc-reader');

function PCXTLoad() {
  // If updated, please REMEMBER to update the mirroring constants in helpers.js
  var COOKIE_NAME = 'PCXT';
  var COOKIE_REGEX = new RegExp("(^| )".concat(COOKIE_NAME, "=([^;]+)"));
  var SCRIPT_LOADED_EVENT = 'PCXT-V3-ScriptLoaded';
  var INITIALIZED_EVENT = 'PCXT-V3-ModuleInitialized';
  var CONTEXT_CHANGE_EVENT = 'PCXT-V3-ContextChanged';
  var COUPON_CHANGE_EVENT = 'PCXT-V3-CouponCodeChanged';
  var VAT_INCLUSIVITY_CHANGE_EVENT = 'PCXT-V3-VatInclusivityChanged';
  var DATE_TIME_CHANGE_EVENT = 'PCXT-V3-EffectiveDateTimeChanged';
  var VAT_INCLUSIVITY_QUERY_PARAMETER = 'PCXTVATINCLUSIVE';
  var DATE_TIME_QUERY_PARAMETER = 'PCXTEFFECTIVEDATETIME'; // Where the remote service lives

  var CONTEXT_SERVICE_BASE_URL = 'https://pricing-context-service.personalization.vpsvc.com'; // Create the base pricingContext object, to be exported globally

  var contextModule = {}; // This will be used to set the domain on the cookie, so any subdomains (eg merch.vpsvc.com) will be included

  var allowedDomains = ['vpsvc', 'vistaprint', 'promotique']; // Set the version of this object. Used when introducing new changes to the context module.
  // PCM_CURRENT_VERSION string will be replaced with the bumped version before publishing.

  contextModule.version = '3.16.0'; // Keep an in-memory version of the cookie just in case `document.cookie` is inaccessible (e.g. during static page generation)
  // or a shopper clears their cookies during their session.

  var inMemoryCookie;
  /* --- Internal Helper Methods --- */

  function timeoutPromise(ms, promise) {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        reject(new Error("timeout"));
      }, ms);
      promise.then(resolve, reject);
    });
  }
  /* 
    Get a resource, with options (options.timeout required)
  */


  async function fetchWithTimeout(resource, options) {
    var response = await timeoutPromise(options.timeout, fetch(resource, _objectSpread({}, options)));
    return response;
  }
  /* 
    Utilize the auth package to get the user's token and canonical id
  */


  var getShopperInfo = function getShopperInfo() {
    try {
      var auth = new VistaprintAuth.WebAuth();
      return {
        authorization: auth.getAuthorizationHeader(),
        shopperId: auth.getCanonicalId()
      };
    } catch (ex) {
      return {};
    }
  };

  var getPageBasedRequestor = function getPageBasedRequestor() {
    if (window && window.location && window.location.href) {
      return "pcxt-".concat(window.location.href.substr(0, 100));
    }

    return 'pcxt';
  };
  /*
    Utility to create new date with a specified number of minutes offset 
  */


  var getNMinutesFromNowUTC = function getNMinutesFromNowUTC(minutes) {
    var now = new Date();
    return new Date(now.getTime() + minutes * 60000);
  };

  var getNowUTC = function getNowUTC() {
    return new Date().toISOString();
  };
  /*
    Validate that the format of the effective date time is correct before sending it as a date
  */


  var validateEffectiveDateTimeFormat = function validateEffectiveDateTimeFormat(effectiveDateTime) {
    /* eslint-disable no-useless-escape */
    // Source: https://regex101.com/r/ufFBTA/2
    var dateTimeRegexp = /\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2]\d|3[0-1])T(?:[0-1]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+|)(?:Z|(?:\+|\-)(?:\d{2}):?(?:\d{2}))/;
    return dateTimeRegexp.test(effectiveDateTime);
  };
  /*
    Emit an event from our module that can be intercepted by the page
  */


  var fireEvent = function fireEvent(eventName, payload) {
    if (typeof document === 'undefined') {
      return;
    }

    var event = new CustomEvent(eventName, {
      detail: payload
    });
    document.dispatchEvent(event);
  };
  /*
    Gets the top-level domain to use when setting the cookie. E.g. gallery.vistaprint.com will return vistaprint.com.
  */


  var domainForCookie = function domainForCookie() {
    if (typeof document === 'undefined' || typeof document.cookie === 'undefined') {
      return '';
    }

    var host = window.location.hostname;

    for (var i = 0; i < allowedDomains.length; i += 1) {
      var domainIndex = host.lastIndexOf(allowedDomains[i]);

      if (domainIndex >= 0) {
        return host.slice(domainIndex);
      }
    }

    return host;
  };
  /*
    Returns a url-friendly context string that represents the context object.
  */


  var encodeContextObject = function encodeContextObject(contextObj) {
    var base64 = btoa(JSON.stringify(contextObj)); // Replace chars in the base64 string to make it url safe per the RFC spec
    // https://tools.ietf.org/html/rfc4648#page-7

    return base64.replace(/\+/g, '-').replace(/=/g, '').replace(/\//g, '_');
  };
  /*
    Returns the context object that the context string represents.
  */


  var decodeContextString = function decodeContextString(contextString) {
    var replacedChars = contextString.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(replacedChars));
  };

  var setCookieContext = function setCookieContext(context) {
    var now = new Date();
    var expireDate = new Date(now.getTime() + 1000 * 604800);
    var encodedContext = encodeContextObject(context);
    var cookieString = "".concat(COOKIE_NAME, "=").concat(encodedContext, ";expires=").concat(expireDate.toUTCString(), ";SameSite=Strict;path=/");

    if (typeof document !== 'undefined' && typeof document.cookie !== 'undefined') {
      var domain = domainForCookie();
      cookieString += ";domain=".concat(domain);
      document.cookie = cookieString;
    }

    inMemoryCookie = cookieString;
  };
  /*
    Get the fields that should be excluded from the context when sent as query string or encoded string
  */


  var getContextStringBlacklist = function getContextStringBlacklist() {
    return ['version', 'vatInclusive', 'expiresAt', 'developmentMode', 'shopperId'];
  };

  var getEmptyContext = function getEmptyContext() {
    return {
      version: 0,
      merchantId: undefined,
      market: undefined,
      couponCode: undefined,
      effectiveDateTime: undefined,
      customerGroups: undefined,
      vatInclusive: undefined,
      expiresAt: undefined,
      developmentMode: undefined,
      shopperId: undefined
    };
  };

  var getRawCookieValue = function getRawCookieValue() {
    var cookieString = typeof document !== 'undefined' && typeof document.cookie !== 'undefined' && document.cookie !== '' && document.cookie.match(COOKIE_REGEX) ? document.cookie : inMemoryCookie;

    try {
      var match = cookieString.match(COOKIE_REGEX);

      if (!match) {
        return null;
      } // The regex match should return an array of length 2. The first value
      // is the 'PCXT=' and the second is the encoded context string value.


      return match[2];
    } catch (ex) {
      return null;
    }
  };
  /*
    Adds all treatments (customer groups) from the browser-side CTC Reader module
    to a context object. This is needed to prevent a race condition where a shopper is put into
    a customer group on page initialization but has not been persisted to the server-side 
    treatment service.
  */


  var addCtcReaderTreatments = function addCtcReaderTreatments(customerGroups) {
    try {
      var treatments = ctcReader.getAllTreatments();

      if (customerGroups) {
        return (0, _toConsumableArray2["default"])(new Set([].concat((0, _toConsumableArray2["default"])(customerGroups), (0, _toConsumableArray2["default"])(treatments))));
      } else {
        return treatments;
      }
    } catch (e) {
      console.log("treatment initialization failed on: ".concat(e.message));
    }

    return customerGroups;
  };
  /*
    Returns current context or the default for the current site.
  */


  var getCurrentContext = function getCurrentContext() {
    var filterOutNullAndEmpties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var filterOutBlacklist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var cv = getRawCookieValue(); // If nothing is in the current cookie, set and return default.

    if (!cv) {
      throw new Error('Pricing context module not initialized.');
    } // Return decoded context, otherwise set and return default.


    try {
      var decodedContext = decodeContextString(cv);

      if (filterOutNullAndEmpties) {
        var filteredContext = Object.keys(decodedContext).filter(function (k) {
          return decodedContext[k] !== undefined;
        }).filter(function (k) {
          return decodedContext[k] !== '';
        })
        /* eslint-disable no-param-reassign */
        .reduce(function (filtered, field) {
          filtered[field] = decodedContext[field];
          return filtered;
        }, {});
        decodedContext = filteredContext;
      }

      if (filterOutBlacklist) {
        var blacklist = getContextStringBlacklist();

        var _filteredContext = Object.keys(decodedContext).filter(function (key) {
          return !blacklist.includes(key);
        })
        /* eslint-disable no-param-reassign */
        .reduce(function (filtered, field) {
          filtered[field] = decodedContext[field];
          return filtered;
        }, {});

        decodedContext = _filteredContext;
      }

      decodedContext.customerGroups = addCtcReaderTreatments(decodedContext.customerGroups);
      return decodedContext;
    } catch (ex) {
      throw new Error('Failed to decode pricing context string.');
    }
  };
  /*
    Get the encoded pricing context object for use as a single parameter
  */


  var getContextString = function getContextString() {
    return encodeContextObject(getCurrentContext(true, true));
  };

  var clearDataOnOrderPlaced = function clearDataOnOrderPlaced() {
    var cachedContext = getCurrentContext();
    cachedContext.couponCode = undefined;
    cachedContext.expiresAt = getNMinutesFromNowUTC(5);
    setCookieContext(cachedContext);
  };

  var getRemoteContextForShopper = async function getRemoteContextForShopper(request) {
    var requestor = getPageBasedRequestor();
    var url = "".concat(CONTEXT_SERVICE_BASE_URL, "/v1/pricingContext/").concat(request.merchantId, "/").concat(request.market, "/").concat(request.shopperInfo.shopperId);
    var queryString = "?developmentMode=".concat(request.developmentMode, "&Requestor=").concat(requestor);
    queryString += request.effectiveDateTime ? validateEffectiveDateTimeFormat(request.effectiveDateTime) ? "&EffectiveDateTime=".concat(request.effectiveDateTime) : '&EffectiveDateTime=clear' : '';
    var response = await fetchWithTimeout(url + encodeURI(queryString), {
      timeout: 1500,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': request.shopperInfo.authorization
      }
    });

    if (response.status >= 400 && response.status < 600) {
      throw new Error("Pricing Context Service returned ".concat(response.status));
    }

    var responseJson = await response.json();
    return responseJson;
  };

  var applyRemoteCoupon = async function applyRemoteCoupon(applyCouponRequest) {
    var requestor = getPageBasedRequestor();
    var url = "".concat(CONTEXT_SERVICE_BASE_URL, "/v1/pricingContext/").concat(applyCouponRequest.merchantId, "/").concat(applyCouponRequest.market, "/").concat(applyCouponRequest.shopperInfo.shopperId, "/applyCoupon");
    var queryString = "?developmentMode=".concat(applyCouponRequest.developmentMode, "&Requestor=").concat(requestor);
    var response = await fetchWithTimeout(url + encodeURI(queryString), {
      method: 'POST',
      body: JSON.stringify({
        couponCode: applyCouponRequest.couponCode
      }),
      timeout: 5000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': applyCouponRequest.shopperInfo.authorization
      }
    });

    if (response.status !== 422 && response.status >= 400 && response.status < 600) {
      throw new Error("Pricing Context Service returned ".concat(response.status));
    }

    var responseJson = await response.json();
    return responseJson;
  };
  /*
    Returns current context or the default for the current site.
  */


  var getContextQueryString = function getContextQueryString(encodeUri) {
    var context = getCurrentContext(true, true);
    var definedContextFields = Object.keys(context);
    var queryString = definedContextFields.filter(function (key) {
      return !Array.isArray(context[key]);
    }).map(function (key) {
      return "".concat(key, "=").concat(context[key]);
    }).join('&');
    var arrayFieldKeys = definedContextFields.filter(function (key) {
      return Array.isArray(context[key]);
    });

    var _loop = function _loop() {
      var arrayFieldKey = arrayFieldKeys[i];
      var arrayFieldQueryString = context[arrayFieldKey].map(function (val) {
        return "".concat(arrayFieldKey, "=").concat(val);
      }).join('&');
      queryString += "&".concat(arrayFieldQueryString);
    };

    for (var i = 0; i < arrayFieldKeys.length; i += 1) {
      _loop();
    }

    return encodeUri ? encodeURI(queryString) : queryString;
  };

  var couponWasApplied = function couponWasApplied(context, couponCode) {
    if (!context.couponCode) {
      return !couponCode;
    }

    return context.couponCode.toUpperCase() === couponCode.toUpperCase();
  };

  var isValidShopperInfo = function isValidShopperInfo(shopperInfo) {
    return shopperInfo && shopperInfo.shopperId && shopperInfo.authorization;
  };

  var setCoupon = async function setCoupon(req) {
    var context = getCurrentContext(); // Verify whether there is a change being processed

    if (!context.couponCode || context.couponCode.toUpperCase() !== req.couponCode.toUpperCase()) {
      try {
        var shopperInfo = getShopperInfo();

        if (!isValidShopperInfo(shopperInfo)) {
          throw new Error("Missing shopper info");
        }

        var request = {
          merchantId: context.merchantId,
          market: context.market,
          shopperInfo: shopperInfo,
          couponCode: req.couponCode,
          developmentMode: context.developmentMode
        };
        var couponAppliedResponse = await applyRemoteCoupon(request);

        var nextContext = _objectSpread(_objectSpread({}, couponAppliedResponse.currentPricingContext), {}, {
          vatInclusive: context.vatInclusive,
          shopperId: shopperInfo.shopperId
        });

        setCookieContext(nextContext);
        fireEvent(COUPON_CHANGE_EVENT, nextContext);
        fireEvent(CONTEXT_CHANGE_EVENT, nextContext);
        return {
          couponApplied: couponWasApplied(nextContext, req.couponCode),
          validationErrors: couponAppliedResponse.validationErrors || [],
          couponInfoLinks: couponAppliedResponse.couponInfoLinks || {},
          currentPricingContext: nextContext
        };
      } catch (err) {
        // eslint-disable-next-line no-console
        console.info('Retaining existing context');
      }
    }

    return {
      couponApplied: couponWasApplied(context, req.couponCode),
      validationErrors: ["UnableToValidate"],
      couponInfoLinks: {},
      currentPricingContext: context
    };
  };

  var setEffectiveDateTime = async function setEffectiveDateTime(effectiveDateTime) {
    var cachedContext = getCurrentContext();

    if (effectiveDateTime === cachedContext.effectiveDateTime) {
      return;
    }

    try {
      var shopperInfo = getShopperInfo();

      if (!isValidShopperInfo(shopperInfo)) {
        throw new Error("Missing shopper info to call for remote context");
      }

      var remoteContext = await getRemoteContextForShopper({
        merchantId: cachedContext.merchantId,
        market: cachedContext.market,
        shopperInfo: shopperInfo,
        effectiveDateTime: effectiveDateTime,
        developmentMode: cachedContext.developmentMode
      });

      var nextContext = _objectSpread(_objectSpread({}, remoteContext), {}, {
        vatInclusive: cachedContext.vatInclusive,
        shopperId: shopperInfo.shopperId
      });

      setCookieContext(nextContext);
      fireEvent(CONTEXT_CHANGE_EVENT, nextContext);

      if (nextContext.effectiveDateTime && nextContext.effectiveDateTime !== cachedContext.effectiveDateTime) {
        fireEvent(DATE_TIME_CHANGE_EVENT, nextContext);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.info("Retaining existing context");
      return;
    }
  };

  var setVatInclusivity = function setVatInclusivity(vatInclusive) {
    var context = getCurrentContext();
    context.vatInclusive = vatInclusive;
    setCookieContext(context); // Fire event, with with payload of current (updated) context

    fireEvent(VAT_INCLUSIVITY_CHANGE_EVENT, context);
    fireEvent(CONTEXT_CHANGE_EVENT, context);
  };
  /*
    Scrap query params from URL and return vatInclusive and/or effectiveDateTime, if present as query string params
  */


  var scrapeURLParams = function scrapeURLParams() {
    var queryParams = {};

    if (typeof window === 'undefined' || typeof window.location === 'undefined' || !window.location.search) {
      return queryParams;
    }

    var urlParams = new URLSearchParams(window.location.search.toUpperCase());
    var vatInclusivityQueryParamString = urlParams.get(VAT_INCLUSIVITY_QUERY_PARAMETER);

    if (vatInclusivityQueryParamString) {
      queryParams.vatInclusive = vatInclusivityQueryParamString === 'TRUE';
    }

    var dateTimeQueryParamString = urlParams.get(DATE_TIME_QUERY_PARAMETER);

    if (dateTimeQueryParamString) {
      queryParams.effectiveDateTime = dateTimeQueryParamString;
    }

    return queryParams;
  };

  var isDefaultVatInclusive = async function isDefaultVatInclusive(pricingMarket, merchantId) {
    if (pricingMarket === undefined || merchantId === undefined) {
      return undefined;
    }

    var sanitizedMerchantId = merchantId.toUpperCase();
    var sanitizedMarket = pricingMarket.toUpperCase();

    if (sanitizedMerchantId === 'VISTAPRINT' && sanitizedMarket === 'FR') {
      try {
        if (window && window.location && window.location.host && window.location.pathname && window.location.host.includes('www.vistaprint.')) {
          var encodedPathName = encodeURIComponent(window.location.pathname);
          var url = "/static/merch/default-tax-inclusivity.prod/v1/".concat(sanitizedMerchantId, "/").concat(sanitizedMarket, "/").concat(encodedPathName);
          var response = await fetchWithTimeout(url, {
            timeout: 500
          });
          var result = await response.json();

          if (result.included === true) {
            return true;
          }
        }
      } catch (e) {
        console.log('error fetching specific default tax inclusivity', e); // no-op
      }

      return false;
    }

    if (sanitizedMarket === 'SG' && new Date().toISOString() >= "2023-04-03T14:00:00.000Z") {
      return true;
    }

    if (sanitizedMerchantId === 'VISTAPRINT' || sanitizedMerchantId === 'VISTAPRINT-FASHION-MASKS' || sanitizedMerchantId === 'VISTAPRINT-PAYPAL') {
      switch (sanitizedMarket) {
        case 'US':
        case 'CA':
        case 'NZ':
        case 'SG':
          return false;

        default:
          return true;
      }
    } else if (sanitizedMerchantId === 'PROMOTIQUE') {
      switch (sanitizedMarket) {
        case 'DE':
        case 'AU':
        case 'IN':
          return true;

        default:
          return false;
      }
    }

    return false;
  };

  var getVatInclusivity = async function getVatInclusivity(cachedContext, newContext, queryParams) {
    return queryParams.vatInclusive !== undefined ? queryParams.vatInclusive : cachedContext.vatInclusive !== undefined ? cachedContext.vatInclusive : newContext.vatInclusive === undefined ? isDefaultVatInclusive(newContext.market, newContext.merchantId) : newContext.vatInclusive;
  };
  /*
    Retrieves the server-side pricing context using the latest cached context.
  */


  var backgroundRefresh = async function backgroundRefresh() {
    var queryParams = scrapeURLParams();
    var initialCachedContext;

    try {
      initialCachedContext = getCurrentContext();
    } catch (ex) {
      return;
    }

    var shopperInfo = getShopperInfo();
    var shopperId = shopperInfo && shopperInfo.shopperId ? shopperInfo.shopperId : '';

    if (!isValidShopperInfo(shopperInfo) || initialCachedContext === undefined || initialCachedContext.merchantId === undefined || initialCachedContext.market === undefined) {
      return;
    }

    var newContext;

    try {
      newContext = await getRemoteContextForShopper({
        merchantId: initialCachedContext.merchantId,
        market: initialCachedContext.market,
        shopperInfo: shopperInfo,
        effectiveDateTime: queryParams.effectiveDateTime,
        developmentMode: initialCachedContext.developmentMode
      });
    } catch (error) {
      return;
    }

    newContext.customerGroups = addCtcReaderTreatments(newContext.customerGroups);
    newContext.vatInclusive = await getVatInclusivity(initialCachedContext, newContext, queryParams);
    newContext.shopperId = shopperId;
    var latestCachedContext;

    try {
      latestCachedContext = getCurrentContext();
    } catch (ex) {
      return;
    } // Check the latest context before persisting the context to avoid race conditions with
    // client-initiated initialization


    if (initialCachedContext.merchantId !== latestCachedContext.merchantId || initialCachedContext.market !== latestCachedContext.market) {
      return;
    }

    setCookieContext(newContext);
    fireEvent(CONTEXT_CHANGE_EVENT, newContext);
  };
  /* --- API Methods --- */

  /*
    Gets the pricing context from the user's cookie. Returns the default
    context for the current site if no cookie is set.
  */


  contextModule.getPricingContext = function getPricingContext() {
    return getCurrentContext();
  };
  /*
    Gets the base 64 encoded pricing context string from the user's cookie. Returns the default
    context for the current site if no cookie is set.
  */


  contextModule.getEncodedContextString = function getEncodedContextString() {
    return getContextString();
  };
  /*
    Gets the current pricing context as a query string that can be used for Product Pricing Service GET requests.
     @param {Boolean} encodeUri - Whether to encode the resulting uri.
  */


  contextModule.getContextAsQueryString = function getContextAsQueryString(encodeUri) {
    return getContextQueryString(encodeUri);
  };
  /*
    Sets an EffectiveDateTime on the user's pricing context cookie.
    Needs to follow ISO 8601 format, see https://en.wikipedia.org/wiki/ISO_8601
     Format: {YYYY}-{MM}-{DD}T{HH}:{mm}:{ss}Z, where
      YYYY -> four digits formatted year
      MM   -> two digits formatted month
      DD   -> two digits formatted day
      HH   -> 24-hours formatted hour
      mm   -> two digits formatted minutes
      ss   -> two digit formatted second
     Example: 2020-09-21T22:55:40Z
     @param {String} effectiveDateTime - EffectiveDateTime the user has entered.
  */


  contextModule.setEffectiveDateTime = async function contextSetEffectiveDateTime(effectiveDateTime) {
    if (typeof effectiveDateTime === 'string' || effectiveDateTime instanceof String) {
      await setEffectiveDateTime(effectiveDateTime.toUpperCase()); // This may fire an event
    } else {
      throw new Error("Must pass a string for parameter 'effectiveDateTime'");
    }
  };
  /*
    Sets a coupon code on the user's pricing context cookie. Note: This will not apply the coupon to
    the shopper's cart.
     @param {String} couponCode - Coupon code the user has entered.
  */


  contextModule.setCouponCode = async function setCouponCode(couponCode) {
    if (typeof couponCode === 'string' || couponCode instanceof String) {
      var couponApplicationInformation = await setCoupon({
        couponCode: couponCode
      }); // This fires an event

      return couponApplicationInformation;
    } else {
      throw new Error("Must pass a string for parameter 'couponCode'");
    }
  };
  /*
    Gets the current coupon code on the user's pricing context cookie.
  */


  contextModule.getCouponCode = function getCouponCode() {
    var context = getCurrentContext();
    return context.couponCode;
  };
  /*
    Sets current vat inclusive state on the user's pricing context cookie.
     @param {Boolean} isInclusive - Whether the current page state is VAT inclusive.
  */


  contextModule.setVatInclusive = function setVatInclusive(isInclusive) {
    var updatedVatInclusivity;

    if (typeof isInclusive === 'boolean' || isInclusive instanceof Boolean) {
      updatedVatInclusivity = isInclusive;
    } else if (isInclusive !== undefined && isInclusive !== '' && (isInclusive.toUpperCase() === 'TRUE' || isInclusive.toUpperCase() === 'FALSE')) {
      updatedVatInclusivity = isInclusive.toUpperCase() === 'TRUE';
    } else {
      throw new Error("Must pass a boolean for parameter 'isInclusive'");
    }

    setVatInclusivity(updatedVatInclusivity); // this fires an event
  };
  /*
    Returns whether the user's pricing context is currently VAT inclusive.
  */


  contextModule.isVatInclusive = function isVatInclusive() {
    var context = getCurrentContext();
    return context.vatInclusive;
  };
  /*
    Returns whether the default user experience for a given market and merchant is tax inclusive.
  */


  contextModule.isDefaultTaxInclusive = async function isDefaultTaxInclusive(market, merchantId) {
    return isDefaultVatInclusive(market, merchantId);
  };
  /* 
    Clears any context pieces which should not persist post-order
  */


  contextModule.orderPlaced = async function orderPlaced() {
    clearDataOnOrderPlaced();
    await setCoupon('');
    return;
  };
  /*
    Returns whether the user's pricing context is currently initialized
  */


  contextModule.isInitialized = function isInitialized(merchantId, market, isDevelopmentMode) {
    var shopperInfo = getShopperInfo();
    var queryParams = scrapeURLParams();
    var cachedContext;

    try {
      cachedContext = getCurrentContext();
    } catch (ex) {
      cachedContext = getEmptyContext();
    }

    if (merchantId && market && isDevelopmentMode !== undefined) {
      var v3ContextInitialized = cachedContext.shopperId !== undefined && ( // You have (A) a context from a previous version - or - (B) a context from a session where auth failed to load
      !shopperInfo.shopperId || shopperInfo.shopperId === cachedContext.shopperId) && // Check cached shopperId against current shopperId, if available
      cachedContext.developmentMode === isDevelopmentMode && // You are in the wrong env
      cachedContext.expiresAt !== undefined && // You have a context from a previous version
      cachedContext.expiresAt > getNowUTC() && // You have an expired context
      cachedContext.merchantId === merchantId.toUpperCase() && // You have a context from the wrong vendor's website
      cachedContext.market === market.toUpperCase() && ( // You have a context from the wrong website for the vendor
      !queryParams.effectiveDateTime || cachedContext.effectiveDateTime === queryParams.effectiveDateTime); // You are attempting to re-init from a session with a different effectivedatetime

      return v3ContextInitialized;
    } // If any of the fields filled in by initialization are undefined, return false


    return !(cachedContext.merchantId === undefined || cachedContext.market === undefined || cachedContext.vatInclusive === undefined);
  };
  /*
    Initializes the pricing context based on the current page's context.
     @param {String} merchantId - Pricing Merchant Id of the current page, ie. 'Vistaprint-fashion-masks'
    @param {String} market - Pricing Market of the current page in the format '{ISO 3166 Alpha 2}'
    @param {Boolean} isDevelopmentMode - Should be true if running in a non-production environment.
     @return {object} The current pricing context object.
  */


  contextModule.init = async function init(merchantId, market) {
    var isDevelopmentMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!(typeof merchantId === 'string' || merchantId instanceof String) || merchantId === '' || merchantId.toLowerCase() === 'undefined') {
      throw new Error("Must pass a non-empty, defined string for parameter 'merchantId'");
    }

    if (!(typeof market === 'string' || market instanceof String) || market === '' || market.toLowerCase() === 'undefined') {
      throw new Error("Must pass a non-empty, defined string for parameter 'market'");
    }

    var queryParams = scrapeURLParams();
    var cachedContext;

    try {
      cachedContext = getCurrentContext();
    } catch (ex) {
      cachedContext = getEmptyContext();
    }

    var shopperInfo = getShopperInfo();
    var shopperId = shopperInfo && shopperInfo.shopperId ? shopperInfo.shopperId : '';
    var contextDataNeedsRefresh = cachedContext.developmentMode !== isDevelopmentMode || // You are in the wrong env
    cachedContext.expiresAt === undefined || // You have a context from a previous version
    cachedContext.expiresAt <= getNowUTC() || // You have an expired context
    cachedContext.merchantId !== merchantId.toUpperCase() || // You have a context from the wrong vendor's website
    cachedContext.market !== market.toUpperCase() || // You have a context from the wrong website for the vendor
    queryParams.effectiveDateTime && cachedContext.effectiveDateTime !== queryParams.effectiveDateTime; // You are attempting to re-init from a session with a different effectivedatetime

    var contextOwnershipNeedsRefresh = shopperId !== '' && cachedContext.shopperId !== shopperId;
    var newContext;

    if (contextDataNeedsRefresh || contextOwnershipNeedsRefresh) {
      try {
        if (!isValidShopperInfo(shopperInfo)) {
          throw new Error("Missing shopper info to call for remote context");
        }

        newContext = await getRemoteContextForShopper({
          merchantId: merchantId,
          market: market,
          shopperInfo: shopperInfo,
          effectiveDateTime: queryParams.effectiveDateTime,
          developmentMode: isDevelopmentMode
        });
      } catch (error) {
        newContext = cachedContext;
        newContext.merchantId = merchantId.toUpperCase();
        newContext.market = market.toUpperCase();
        newContext.expiresAt = getNMinutesFromNowUTC(1);
        newContext.developmentMode = isDevelopmentMode;
      }
    } else {
      newContext = cachedContext;
    }

    newContext.customerGroups = addCtcReaderTreatments(newContext.customerGroups);
    newContext.vatInclusive = await getVatInclusivity(cachedContext, newContext, queryParams);
    newContext.shopperId = shopperId;
    setCookieContext(newContext); // Fire event, pricing context initialized with payload of current context

    fireEvent(INITIALIZED_EVENT, newContext);
    return newContext;
  };
  /* --- Module Definition --- */


  if (isValidShopperInfo(getShopperInfo())) {
    backgroundRefresh();
  } else {
    if (typeof window !== 'undefined') {
      window.addEventListener('userIdentity', function refresh() {
        window.removeEventListener('userIdentity', refresh);
        backgroundRefresh();
      });
    }
  } // If document is not available, just return the module.
  // During static site generation document will not be available.


  if (typeof document === 'undefined') {
    module.exports = contextModule;
    return;
  } // Add the module to the page


  document.pcxtV3 = contextModule; // Tell the page that the the module was loaded

  fireEvent(SCRIPT_LOADED_EVENT, {
    version: contextModule.version
  });
}

;
PCXTLoad();